"use client";

import { registerPlugin } from "@capacitor/core";
import { isAndroidNativeApp } from "@/lib/nativePlatform";

const ZERO_AD_ID = "00000000-0000-0000-0000-000000000000";

const NativeIdentity = registerPlugin("NativeIdentity");

export async function getNativeAdvertisingIdentity() {
  if (!isAndroidNativeApp()) return null;

  try {
    const result = await NativeIdentity.getAdvertisingIdentity();
    const id = String(result?.id || "").trim();
    if (!result?.available || !id || id === ZERO_AD_ID || result?.limitAdTracking) {
      return null;
    }

    return {
      entityId: id,
      entityidType: result?.type || "gaid",
      entityidAlgo: "clear",
      entityidOwner: result?.appId || "space.sproutly.android",
    };
  } catch (err) {
    console.warn("[nativeIdentity] failed to read advertising identity", err);
    return null;
  }
}
